var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('div',{staticClass:"bottom_A"},[_c('img',{attrs:{"src":require("../assets/logo.png")}}),_c('span',[_vm._v("xxxxxxxxxxxxx")])]),_c('div',{staticClass:"bottom_B"},[_c('img',{attrs:{"src":require("../assets/logo.png")}}),_c('span',[_vm._v("xxxxxxxxxxxxx")])])])
}]

export { render, staticRenderFns }